import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { EditClientContractTerm } from '~/features/EditClientContractTerm';
import { EditClientContractTermHeader } from '~/features/EditClientContractTermHeader';
import { getClientContractListLink } from '~/utils/getLinks';
import styles from './styles.module.scss';

/**
 * 企業契約期間 編集 Screen
 *
 * - DetailHeader（パンくず・契約プラン情報）は EditClientContractTermHeader に委譲する（中身は T02 / PEN-979）
 * - 編集フォーム本体は EditClientContractTerm に委譲する（中身は T03 / PEN-980・T04 / PEN-981）
 * - clientId・termId はどちらもパスパラメータで受け取る
 */
export const Screen: React.FC = () => {
  const { clientId, termId } = useParams<{ clientId: string; termId: string }>();

  const parsedClientId = Number.parseInt(clientId ?? '', 10);
  const parsedTermId = Number.parseInt(termId ?? '', 10);

  if (Number.isNaN(parsedClientId) || Number.isNaN(parsedTermId)) {
    return <Navigate to={getClientContractListLink()} replace />;
  }

  return (
    <>
      <Suspense fallback={<Loader />}>
        <EditClientContractTermHeader clientId={parsedClientId} termId={parsedTermId} />
      </Suspense>
      <main className={styles.body}>
        <Suspense fallback={<Loader />}>
          <EditClientContractTerm clientId={parsedClientId} termId={parsedTermId} />
        </Suspense>
      </main>
    </>
  );
};
